import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { QuestionMark } from "@/assets/icons/icons";

export const SupportLinkItem = () => {
  const { t } = useTranslation();

  return (
    <a
      tabIndex={0}
      aria-label={t("Common.support")}
      href={t("Footer.support.url")}
      target="_blank"
      rel="noreferrer"
      className={clsx(
        "group flex gap-2 py-2 text-lg text-white hover:font-semibold hover:text-secondary-100 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 xl:py-0",
      )}
    >
      <div className="flex h-10 items-center justify-center border-transparent group-hover:border-white group-hover:bg-transparent xl:h-10 xl:w-10 xl:rounded-full xl:border-2 xl:bg-white">
        <QuestionMark className="w-6 [&>path]:fill-white [&>path]:stroke-white group-hover:[&>path]:fill-white xl:[&>path]:fill-primary-100" />
      </div>
      <span className={clsx("my-auto whitespace-nowrap pb-px xl:hidden")}>
        {t("Common.support")}
      </span>
    </a>
  );
};
